// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-dialog-content {
  width: 650px;
  height: 450px;
  overflow: auto;
}

.header-dialog {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
}

.mat-paginator-range-actions {
  margin-left: 30px !important;
}

table {
  width: 100%;
  margin: auto;
  table-layout: auto;
}

table,
td,
th {
  border-collapse: collapse;
}

app-paginator {
  justify-content: flex-end;
}

tr.mat-row:hover {
  background-color: wheat;
  cursor: pointer;
}

.group-search-form input {
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 30px;
  outline: none;
  line-height: 30px;
  padding: 0 8px 0 30px;
  max-width: 360px;
  height: 30px;
  transition: max-width 0.2s ease-in-out;
}

.group-search-form input::-webkit-input-placeholder {
  color: #999;
}

.group-search-form input:focus::-webkit-input-placeholder {
  color: #ccc;
}

.group-search-form input::-moz-placeholder {
  color: #999;
}

.group-search-form input:focus::-moz-placeholder {
  color: #ccc;
}

.group-search-form .fa-search {
  background: transparent;
  color: #aaa;
  font-size: 16px;
  border: none;
  outline: none;
  padding: 0;
  position: absolute;
  left: 0;
  top: 0;
  height: 30px;
  margin-right: 850px;
}

.group-search-form .fa-search:before {
  position: absolute;
  top: 6px;
  left: 9px;
}

.group-search-form {
  padding: 0;
  position: fixed;
  width: 400px;
  margin-top: -6px;
  margin-right: 600px;
}

.fa-search {
  background: transparent;
  color: #aaa;
  font-size: 16px;
  border: none;
  outline: none;
  padding: 0;
  position: absolute;
  left: 0;
  top: 0;
  height: 30px;
  margin-right: 850px;
}

.group-live-search {
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: 0 5px 12px 2px rgba(0, 0, 0, 0.25);
  margin-top: 45px;
  position: absolute;
  width: 360px;
  z-index: 999;
  overflow-y: auto;
}

.group-live-search ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.group-live-search a {
  cursor: pointer;
  padding: 10px;
}

.group-live-search a:hover {
  background-color: #f4f5f7;
  text-decoration: none;
}

.group-live-search .name, .group-live-search .code {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.group-live-search .code {
  color: #999;
  font-size: 12px;
}

.group-live-search .not-found {
  padding: 10px 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/e-form/dialog/group-list/group-list.component.scss"],"names":[],"mappings":"AAAA;EACG,YAAA;EACA,aAAA;EACA,cAAA;AACH;;AAEA;EACG,aAAA;EACA,yBAAA;EACA,sBAAA;AACH;;AAEA;EACG,4BAAA;AACH;;AAEA;EACG,WAAA;EACA,YAAA;EACA,kBAAA;AACH;;AAEA;;;EAGG,yBAAA;AACH;;AAEA;EACG,yBAAA;AACH;;AAEA;EACG,uBAAA;EACA,eAAA;AACH;;AAEA;EACG,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,sCAAA;AACH;;AAEA;EACG,WAAA;AACH;;AAEA;EACG,WAAA;AACH;;AAEA;EACG,WAAA;AACH;;AAEA;EACG,WAAA;AACH;;AAEA;EACG,uBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;AACH;;AAEA;EACG,kBAAA;EACA,QAAA;EACA,SAAA;AACH;;AAEA;EACG,UAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AACH;;AAEA;EACG,uBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,mBAAA;AACH;;AAEA;EACG,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AACH;;AAGA;EACG,gBAAA;EACA,SAAA;EACA,UAAA;AAAH;;AAGA;EACG,eAAA;EACA,aAAA;AAAH;;AAGA;EACG,yBAAA;EACA,qBAAA;AAAH;;AAIA;EACG,gBAAA;EACA,uBAAA;EACA,mBAAA;AADH;;AAIA;EACG,WAAA;EACA,eAAA;AADH;;AAIA;EACG,kBAAA;AADH","sourcesContent":[".mat-dialog-content {\n   width: 650px;\n   height: 450px;\n   overflow: auto;\n}\n\n.header-dialog {\n   display: flex;\n   justify-content: flex-end;\n   flex-direction: column;\n}\n\n.mat-paginator-range-actions {\n   margin-left: 30px !important;\n}\n\ntable {\n   width: 100%;\n   margin: auto;\n   table-layout: auto;\n}\n\ntable,\ntd,\nth {\n   border-collapse: collapse;\n}\n\napp-paginator {\n   justify-content: flex-end;\n}\n\ntr.mat-row:hover {\n   background-color: wheat;\n   cursor: pointer;\n}\n\n.group-search-form input {\n   background: #fff;\n   border: 1px solid #ccc;\n   border-radius: 30px;\n   outline: none;\n   line-height: 30px;\n   padding: 0 8px 0 30px;\n   max-width: 360px;\n   height: 30px;\n   transition: max-width .2s ease-in-out;\n}\n\n.group-search-form input::-webkit-input-placeholder {\n   color: #999;\n}\n\n.group-search-form input:focus::-webkit-input-placeholder {\n   color: #ccc;\n}\n\n.group-search-form input::-moz-placeholder {\n   color: #999;\n}\n\n.group-search-form input:focus::-moz-placeholder {\n   color: #ccc;\n}\n\n.group-search-form .fa-search {\n   background: transparent;\n   color: #aaa;\n   font-size: 16px;\n   border: none;\n   outline: none;\n   padding: 0;\n   position: absolute;\n   left: 0;\n   top: 0;\n   height: 30px;\n   margin-right: 850px;\n}\n\n.group-search-form .fa-search:before {\n   position: absolute;\n   top: 6px;\n   left: 9px;\n}\n\n.group-search-form {\n   padding: 0;\n   position: fixed;\n   width: 400px;\n   margin-top: -6px;\n   margin-right: 600px;\n}\n\n.fa-search {\n   background: transparent;\n   color: #aaa;\n   font-size: 16px;\n   border: none;\n   outline: none;\n   padding: 0;\n   position: absolute;\n   left: 0;\n   top: 0;\n   height: 30px;\n   margin-right: 850px;\n}\n\n.group-live-search {\n   background-color: #fff;\n   box-sizing: border-box;\n   box-shadow: 0 5px 12px 2px rgba(0, 0, 0, 0.25);\n   margin-top: 45px;\n   position: absolute;\n   width: 360px;\n   z-index: 999;\n   overflow-y:auto;\n\n}\n\n.group-live-search ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n\n.group-live-search a {\n   cursor: pointer;\n   padding: 10px;\n}\n\n.group-live-search a:hover {\n   background-color: #f4f5f7;\n   text-decoration: none;\n}\n\n\n.group-live-search .name, .group-live-search .code {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n}\n\n.group-live-search .code {\n   color: #999;\n   font-size: 12px;\n}\n\n.group-live-search .not-found {\n   padding: 10px 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
